import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GlobalDialogsProvider } from "@/components/GlobalDialogs";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import LearnEarn from "@/pages/LearnEarn";
import CourseDetail from "@/pages/CourseDetail";
import Studio from "@/pages/Studio";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Collaborate from "@/pages/Collaborate";

import MyEnrolments from "@/pages/MyEnrolments";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GlobalDialogsProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/projects" element={<Navigate to="/blog" replace />} />
              <Route path="/projects/:slug" element={<Navigate to="/blog" replace />} />
              <Route path="/learn-earn" element={<LearnEarn />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/collaborate" element={<Collaborate />} />
              <Route path="/my-enrolments" element={<MyEnrolments />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </GlobalDialogsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
